import './App.css';
import React, { useState, useEffect } from "react";
import Login from './components/login/login';
import DBPortalApp from './dbportalapp'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Security, SecureRoute, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import config from './config';


const oktaAuth = new OktaAuth(config.oidc);


function App() {

  const [showLogin, setShowLogin] = useState(true)

  const [loadApp, setLoadApp] = useState(false)

  const BASE_URL = process.env.REACT_APP_BASE_URL;



  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location.href = window.location.origin + toRelativeUrl(originalUri || '/', window.location.origin);
    setShowLogin(false)
  };


  useEffect(() => {
    var authObject = oktaAuth['authStateManager']['_authState']
    if(oktaAuth.isAuthenticated) {
      if (localStorage.getItem('db_portal_app_apikey') === '') {
        if(authObject) {
          sucessfullLogin(authObject)
          setLoadApp(true)
        }
      }
      setShowLogin(false)
    } else {
      
    }

  }, [])


  function handleOauthLogin(email) {
    oktaAuth.signInWithRedirect({originalUri : '/', loginHint : email})
  }

  function sucessfullLogin(authObject) {
    var accesss_token = authObject['accessToken']['accessToken']
    var email = authObject['idToken']['claims']['email']
    var user_name = authObject['idToken']['claims']['name']
    fetch(BASE_URL + '/v1/api_callback', {
        method : 'POST',
        headers : {
          'Accept':'application/json',
          'Content-Type':'application/json'
        },
        body : JSON.stringify({
              "key": accesss_token ,
              "email": email,
              "user_name" : user_name
          })
      }).then(res => res.json())
      .then((data) => {
        console.log("sucessfullLogin inside method")
          if ( data['message']['status'] === "Success") {
            var apiKey = data['message']['api_key']
            var role = data['message']['role']
            localStorage.setItem('db_portal_oauth_token', accesss_token)
            localStorage.setItem('db_portal_app_apikey', apiKey)
            localStorage.setItem('last_active_time', JSON.stringify(Date.now()))
            localStorage.setItem('db_portal_user_name', user_name)
            localStorage.setItem('db_portal_user_email', email)
            localStorage.setItem('db_portal_user_role', role)
            setLoadApp(true)
            setShowLogin(false)
          } else {
            setLoadApp(false)
            setShowLogin(true)
          }
      })
      .catch(console.log)
  }

  function handleLogout() {
    var apikey = localStorage.getItem('db_portal_app_apikey')
    var oauth_token = localStorage.getItem('db_portal_oauth_token')
    localStorage.setItem('db_portal_app_apikey', '')
    localStorage.setItem('last_active_time', '')
    localStorage.setItem('db_portal_user_name', '')
    localStorage.setItem('db_portal_user_email', '')
    localStorage.setItem('db_portal_user_role', '')
    localStorage.setItem('db_portal_oauth_token', '') 
    oktaAuth.tokenManager.clear()
    fetch(BASE_URL + '/v1/logout', {
        method : 'POST',
        headers : {
          'Accept':'application/json',
          'Content-Type':'application/json',
          'x-api-key' : apikey,
          'oauth-token' : oauth_token
        },
      }).then(res => res.json())
      .then((data) => {
      })
      .catch(console.log)
    setShowLogin(true)
  }

  return (
    <div className="App">
      {showLogin 
        ?  <Login handleLogin={handleOauthLogin} />
        : 
          <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
    >
          <BrowserRouter>
            <Switch>
                <Route path="/login/callback" component={LoginCallback} />
                <Route path="/login">
                  <Login handleLogin={handleOauthLogin} />
                </Route>
                <SecureRoute path="/">
                  <DBPortalApp sucessfullLogin={sucessfullLogin} handleLogout={handleLogout} loadApp={loadApp}/>
                </SecureRoute>
            </Switch>
          </BrowserRouter>
          </Security>
      }
    </div>
  );
}

export default App;
